import { Select } from "@chakra-ui/react";
import React, { useEffect, useRef } from "react";
import { IQuestionProps } from "../../../types";
import { useForm } from "react-hook-form";
import QuestionWrapper from "../../QuestionWrapper";

const SingleSelect: React.FC<IQuestionProps> = ({
  defaultValue,
  onSubmit,
  onDirty,
  isHideSubmit,
  ...restProps
}) => {
  const { id, options, nextOnSelect, mandatory } = restProps;

  const {
    register,
    handleSubmit,
    formState: { isDirty, isValid },
    trigger,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      value: defaultValue as string,
    },
  });

  useEffect(() => {
    trigger();
  }, [trigger]);

  useEffect(() => {
    if (!nextOnSelect && isDirty && onDirty) {
      onDirty();
    }
  }, [nextOnSelect, isDirty, onDirty]);

  const buttonSubmitRef = useRef<HTMLButtonElement>(null);

  return (
    <form
      id={`question-${id}`}
      onSubmit={handleSubmit((formData) => {
        if (onSubmit) {
          const selectedData = options?.find(
            (elm) => elm.value === formData.value
          );

          onSubmit(formData.value as string, {
            nextRoute: selectedData?.routeId,
          });
        }
      })}
    >
      <QuestionWrapper
        isValid={isValid}
        submitButtonProps={{
          display: isHideSubmit ? "none" : "block",
          disabled: !isValid && !nextOnSelect,
          ref: buttonSubmitRef,
        }}
        {...restProps}
      >
        <Select
          placeholder="Select"
          size={{ base: "sm", md: "md" }}
          width="auto"
          _focus={{
            background: "#ffffffcc",
          }}
          variant="filled"
          {...register("value", {
            required: mandatory,
            onChange: async () => {
              if (onDirty && nextOnSelect) {
                await onDirty();
                buttonSubmitRef.current?.click();
              }
            },
          })}
        >
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </QuestionWrapper>
    </form>
  );
};

export default SingleSelect;
